






























































































import { Component, Vue } from "vue-property-decorator";
import Minuteur from "../components/Minuteur.vue";
import store, { modules } from "../store";
import { Pavillon } from "../models/Pavillon";
import { Niveau } from "../models/Niveau";
import {
  MMessage,
  MRadioGroup,
  MRadio,
  MSpinner,
  MAutocomplete,
  MDialog,
  MAutoCompleteResult,
  MPanel,
  MLink,
  MIconFile,
  MIcon,
} from "@ulaval/modul-components";
import { Casier } from "../models/Casier";
import BoutonsNavigation from "../components/BoutonsNavigation.vue";
import router from "../router";

@Component({
  components: {
    MMessage,
    MRadioGroup,
    MRadio,
    MSpinner,
    MAutocomplete,
    MDialog,
    Minuteur,
    BoutonsNavigation,
    MPanel,
    MLink,
    MIconFile,
    MIcon,
  },
})
export default class Casiers extends Vue {
  private listeResultats: MAutoCompleteResult[] = [];
  private afficherRechercheCasier: boolean = false;
  private afficherPopUpNiveauVide: boolean = false;
  private afficherPopUpErreurCasierNonDispo: boolean = false;
  private chargementEnCours: boolean = false;
  private saisieRecherche: string = "";
  private TypeSelection = Object.freeze({
    Suggestion: "suggestion",
    Recherche: "recherche",
  });
  private propositionCasier: Casier | null = null;
  private suggestionDesactive: boolean = false;

  private isPlanPresent: boolean = false;
  private dirPlan: string = "/plans/";
  private urlPlan: string = "";

  private async mounted(): Promise<void> {
    store.commit(modules.trainProgression.mutations.activerPrecedent.name);

    this.rafraichirUrlPlan();

    await this.recupererCasiers();
  }

  private async recupererCasiers(): Promise<void> {
    this.chargementEnCours = true;

    try {
      await store.dispatch(
        modules.cds.actions.recupererCasiersDisposEtBonEtatParNiveau.name,
        {
          niveauId: store.state.utilisateur.niveau?.id,
          idUtilisateur: this.$msal.data.query.profile?.id || "",
          vm: this,
        }
      );

      if (this.casiers.length === 0) {
        this.afficherPopUpNiveauVide = true;
      } else {
        this.verrouillerProposition();
      }
    } catch (e) {
      store.commit(
        modules.cds.mutations.recupererCasiersDisposEtBonEtatParNiveauEchec.name
      );

      store.commit(modules.utilisateur.mutations.sauvegarderCasier.name, null);

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }

    this.chargementEnCours = false;
  }

  get casiers(): Casier[] {
    return store.state.cds.casiers;
  }

  get propositionNoCasier(): string {
    let noCasier: string = "";
    if (this.propositionCasier !== null) {
      noCasier = this.propositionCasier.numero;
    }
    return noCasier;
  }

  private async verrouillerProposition(): Promise<void> {
    // On veut toujours prioriser le premier casier
    const indexCasier = 0;

    if (this.casiers.length > indexCasier) {
      this.propositionCasier = this.casiers[indexCasier];
      this.actualiserVerrouUtilisateur(this.propositionCasier.id);
    }
  }

  private async actualiserVerrouUtilisateur(idCasier: string): Promise<void> {
    try {
      await store.dispatch(
        modules.cds.actions.actualiserVerrouUtilisateur.name,
        {
          vm: this,
          idCasier: idCasier,
          idUtilisateur: this.$msal.data.query.profile?.id || "",
          delaiVerrou: this.delaiVerrou,
        }
      );
    } catch (e) {
      this.suggestionDesactive = true;

      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        "Une erreur est survenue lors de l'obtention de la priorité pour casier suggéré. Veuillez rafraîchir la page ou sélectionner un casier spécifique."
      );
    }
  }

  private sauvegarderCasier(id: string) {
    if (id === "") {
      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
    } else {
      store.commit(modules.trainProgression.mutations.activerSuivant.name);

      const casier = this.casiers.find((casier) => casier.id === id);

      store.commit(
        modules.utilisateur.mutations.sauvegarderCasier.name,
        casier
      );
    }
  }

  private filtrerListeCasiers(recherche: string) {
    // On effectue une recherche sur tous les casiers disponibles à l'aide de leur numéro de casier.
    this.listeResultats = this.casiers
      .filter((casier) =>
        casier.numero.toLowerCase().includes(recherche.trim().toLowerCase())
      )
      .map((casier) => ({
        label: casier.numero,
        value: casier.id,
      }));
  }

  private determinerTypeSelection(selectedId: string): void {
    if (selectedId === this.TypeSelection.Recherche) {
      this.afficherRechercheCasier = true;

      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
    } else if (selectedId === this.TypeSelection.Suggestion) {
      this.afficherRechercheCasier = false;

      if (this.propositionCasier !== null) {
        this.sauvegarderCasier(this.propositionCasier.id);
      }

      store.commit(modules.trainProgression.mutations.activerSuivant.name);
    }
  }

  private async veriferDisponibiliteCasier(): Promise<void> {
    if (this.casierUtilisateur !== null) {
      try {
        const disponible: boolean = await store.dispatch(
          modules.cds.actions.recupererDisponibiliteCasier.name,
          {
            vm: this,
            idCasier: this.casierUtilisateur.id,
            idUtilisateur: this.$msal.data.query.profile?.id || "",
          }
        );

        if (disponible) {
          this.navSuivant();
        } else {
          this.afficherPopUpErreurCasierNonDispo = true;

          // On efface la saisie faite par l'utilisateur, car elle pourrait être
          // erronée une fois les casiers rafraîchis.
          this.saisieRecherche = "";

          // On efface la sélection utilisateur, car le casier n'est disponible.
          store.commit(
            modules.utilisateur.mutations.sauvegarderCasier.name,
            null
          );
        }
      } catch (e) {
        store.commit(modules.trainProgression.mutations.desactiverSuivant.name);

        store.commit(
          modules.utilisateur.mutations.sauvegarderCasier.name,
          null
        );

        store.commit(
          modules.applicatif.mutations.modifierMessageErreur.name,
          store.state.applicatif.messageErreurParDefaut
        );
      }
    }
  }

  get casierUtilisateur(): Casier | null {
    return store.state.utilisateur.casier;
  }

  get delaiVerrou(): string | null {
    // Obtenir la clé de la définition de la variable d'environnement
    const definitionsVariable = store.state.cds.definitionsVariablesEnv.find(
      (definition) =>
        definition.nomVariableEnv ===
        store.state.applicatif.variableEnvCleDelaiVerrou
    );

    if (definitionsVariable !== undefined) {
      // Obtenir la valeur de la variable d'environnement pour le courriel
      const valeursVariable = store.state.cds.valeursVariablesEnv.find(
        (variableEnv) => variableEnv.definitionId === definitionsVariable.id
      );

      if (valeursVariable !== undefined) {
        return valeursVariable.valeur;
      }
    }

    return null;
  }

  async navPrecedent(): Promise<void> {
    const route: string = await store.dispatch(
      modules.trainProgression.actions.etapePrecedente.name
    );
    router.push({ name: route });
  }

  async navSuivant(): Promise<void> {
    if (this.casierUtilisateur !== null) {
      this.actualiserVerrouUtilisateur(this.casierUtilisateur.id);

      const route: string = await store.dispatch(
        modules.trainProgression.actions.etapeSuivante.name
      );
      router.push({ name: route });
    }
  }

  get pavillon(): Pavillon | null {
    return store.state.utilisateur.pavillon;
  }

  get nomPavillon(): string {
    return this.pavillon?.nomPavillon || "";
  }

  get niveau(): Niveau | null {
    return store.state.utilisateur.niveau;
  }

  get nomPlan(): string {
    var nomPlanTemp: string = this.niveau?.nomPlan || "";

    this.isPlanPresent = nomPlanTemp.length > 0;

    return nomPlanTemp;
  }

  get nomNiveau(): string {
    return this.niveau?.nomNiveau || "";
  }

  private rafraichirUrlPlan(): void {
    this.urlPlan = this.dirPlan + this.nomPlan;
  }
}
